export default __webpack_public_path__ + "static/media/logo.0f0fc776.svg";